export const validateDomain = domain => {
  const specialCharacters = ' !#"\\$%&\'()*+,./:;<=>?@[]^_`{|}~'.split('');

  for (let i = 0; i < specialCharacters.length; i++) {
    if (domain.includes(specialCharacters[i])) {
      return false;
    }
  }

  return true;
};

export const validateCompanyId = uid => {
  if (
    uid.includes('.') ||
    uid.includes('$') ||
    uid.includes('[') ||
    uid.includes(']') ||
    uid.includes('#') ||
    uid.includes('/')
  ) {
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/utils/validate.js